import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=86479d66&scoped=true&lang=pug&"
import script from "./EmployeeForm.vue?vue&type=script&lang=ts&"
export * from "./EmployeeForm.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&id=86479d66&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86479d66",
  null
  
)

export default component.exports